import * as React from 'react';
import { LogoXINGButterflyBlack, LogoXINGButterflyDuo, LogoXINGButterflyInvert, LogoXINGButterflyWhite, } from '@xingternal/illustrations';
import { Styled } from './butterfly.styles';
const DEFAULT_SIZE = 28;
export const Butterfly = ({ className, inverted = false, size = DEFAULT_SIZE, variant = 'duo', ...props }) => {
    const width = size;
    const height = Math.round((31 * size) / DEFAULT_SIZE); // Calculate height of butterfly from viewbox
    const defaultProps = {
        height,
        width,
    };
    return (React.createElement(Styled.Butterfly, { className: className, "data-xds": "Butterfly" },
        variant === 'duo' && !inverted && (React.createElement(LogoXINGButterflyDuo, { ...defaultProps, ...props })),
        variant === 'duo' && inverted && (React.createElement(LogoXINGButterflyInvert, { ...defaultProps, ...props })),
        variant === 'mono' && !inverted && (React.createElement(LogoXINGButterflyBlack, { ...defaultProps, ...props })),
        variant === 'mono' && inverted && (React.createElement(LogoXINGButterflyWhite, { ...defaultProps, ...props }))));
};
Butterfly.displayName = 'Butterfly';
//# sourceMappingURL=butterfly.js.map